import productionService from '../service/production'
const state = {
    query: {
        macAddress: "",
        customer: "",
        page: 1,
        pageSize: 10,
    },
    searchResult: {
        total: 0,
        productions: [],
    },
    loading: false
}

const actions = {
    GenerateCerts({ commit }, certsInfo) {
        commit('setLoading', true)
        return productionService.generateCerts(certsInfo).then(data => {
            commit('setLoading', false)
            return data;
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    updateProduction({ commit }, production) {
        commit('setLoading', true)
        return productionService.updateProduction(production).then(data => {
            commit('setproduction', production);
            commit('setLoading', false)
            return data;
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    splitProduction({ commit }, production) {
        commit('setLoading', true)
        return productionService.splitProduction(production).then(data => {
            commit('setLoading', false)
            return data;
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    createProduction({ commit }, production) {
        commit('setLoading', true)
        return productionService.createProduction(production).then(data => {
            production._id = data._id;
            commit('setLoading', false)
            return data;
        })
    },
    generateMacAddress({ commit }, form) {
        return productionService.generateMacAddress(form).then(data => {
            commit('setLoading', false)
            return data;
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    getProductions({ commit }, query) {
        commit('setLoading', true)
        return productionService.getProductions(query).then(productions => {
            commit('setproductions', productions);
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    sendMailproductions({ commit }, production) {
        commit('setLoading', false)
        return productionService.sendMailproductions(production)
    },
}
const mutations = {
    setproduction(state, production) {
        let index = state.searchResult.productions.findIndex(x => x._id == production._id)
        if (index != -1) {
            state.searchResult.productions[index].statu = production.newStatu
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setproductions(state, productions) {
        state.searchResult = productions
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



